import { RCoefficientMajorationBatiment_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'
const Data = require('../json/CoefficientMajorationBatiment.json')

//CoefficientMajorationBatimentSorted
export function fetchCoefficientMajorationBatiment(uuid: string): RCoefficientMajorationBatiment_Type {
  return fetchGeneric(Data, uuid)
}

export function fetchCoefficientMajorationBatimentSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(Data)
}
